export enum MemberEvaluatorStatusType {
  Invited = 'Invited',
  EvaluationCompleted = 'EvaluationCompleted',
}

export class MemberEvaluator {
  isAnonymousEvaluation: boolean;
  anonymousId: string;
  email: string;
  personId: string;
  fullName: string;
  status: MemberEvaluatorStatusType;
}
